import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api, { formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { homeFor } from "../components/ProtectedRoute";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    window.history.replaceState(null, "", location.pathname);
    if (!sessionId) { navigate("/accedi", { replace: true }); return; }
    api.post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => { setUser(data); navigate(homeFor(data.role), { replace: true, state: { user: data } }); })
      .catch((e) => { setUser(false); setError(formatApiErrorDetail(e.response?.data?.detail) || "Accesso con Google non riuscito"); });
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen paper-grain flex items-center justify-center px-6" data-testid="auth-callback">
      {error ? (
        <div className="text-center max-w-sm">
          <p className="text-sm text-red-600 mb-4" data-testid="auth-callback-error">{error}</p>
          <button onClick={() => navigate("/accedi", { replace: true })} className="text-sm font-semibold text-[#0F4C81] underline" data-testid="auth-callback-back">Torna all'accesso</button>
        </div>
      ) : (
        <Loader2 className="w-6 h-6 animate-spin text-[#0F4C81]" />
      )}
    </div>
  );
}
